import { Amplify } from "aws-amplify";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_USER_POOL_CLIENT_ID,
      identityPoolId: "",
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_COGNITO_USER_POOL_DOMAIN,
          scopes: [
            "phone",
            "email",
            "profile",
            "openid",
            "aws.cognito.signin.user.admin"
          ],
          redirectSignIn: [
            window.location.hostname === "localhost"
              ? "http://localhost:3000/oauth2/login-redirect"
              : `https://${window.location.hostname}/oauth2/login-redirect`
          ],
          redirectSignOut: [
            window.location.hostname === "localhost"
              ? "http://localhost:3000/"
              : `https://${window.location.hostname}`
          ],
          responseType: "code"
        }
      }
    }
  }
});

export default Amplify;
